import { ConfigurationSchema } from '@jbrowse/core/configuration'

/**
 * #config LinearVariantMatrixRenderer
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars

const LinearVariantMatrixRenderer = ConfigurationSchema(
  'LinearVariantMatrixRenderer',
  {},
  { explicitlyTyped: true },
)
export default LinearVariantMatrixRenderer
